import React, { Component } from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { withRouter, NavLink } from "react-router-dom"
//import { NavLink} from "react-router-dom";
import axios from 'axios'
import { connectNode } from '../../../../utils/global'
import { escapeHtml } from '../../../../utils/textFunctions'
import '../../../../styles/assets/css/admin/form3.css'
import { loadLocationWithMessage } from '../../../../actions/location'

import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline'

import TextField from '@material-ui/core/TextField'
import Button from '@material-ui/core/Button'
import FormControl from '@material-ui/core/FormControl'
//import Select from '@material-ui/core/Select'
//import { ListSubheader } from '@material-ui/core'
//import MenuItem from '@material-ui/core/MenuItem'
import AddBoxIcon from '@material-ui/icons/AddBox'
import CancelIcon from '@material-ui/icons/Cancel'
//import { makeStyles } from "@material-ui/core/styles";
import PatientHead3 from "../../patient/patient_head3"
import { contact, type, reason, outcome, yes_no } from '../variables/contact_logs.js'
import { completion, adherence_reason } from '../variables/treatment_plan.js'
import Select from 'react-select'

class AssignWorksheets extends Component {
  constructor() {
      super()
      this.state = {
          status: false,
          status_submit: true,
          message: '',
          wid: 0,
          w_name: '',
          patient_list: [],
          patient_group: [],
          get_patient: 0,
          dataList: [],
          editMode: false,
          category_name: '',
      }
  }

  componentDidMount() {
    this.getData()
  }

  getData = () => {
    axios({
      method: 'post',
      url: connectNode + 'admin/worksheets/get_worksheet_patient_list2',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json;charset=UTF-8'
      },
      data: {
        wid: this.props.match.params.wid,
        uid: this.props.authReducer.uid,
        user_role: this.props.authReducer.role,
      }
    })
    .then((result) => {
      //console.log(result['data'])
      if(result['data'].length > 0) {
        this.setState({
          wid: this.props.match.params.wid,
          w_name: result['data'][0].value[0].name,
          patient_list: result['data'][2].value,
          patient_group: result['data'][1].value,
          category_name: result['data'][0].value[0].category_name
        })
      }
    })
  }

  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    })
  }

  handleSelectPatient = (e) => {
    if(e.value > 0) {
      this.setState({
        get_patient: e.value,
      })
    }
  }

  add_patient = () => {
    //console.log(this.textInput.current[0])
    var getVal = this.state.get_patient
    var getPatientGroup = this.state.patient_group
    var getName = this.findLabelByValue(this.state.patient_list, getVal)
    const found = getPatientGroup.some(el => el.pid === getVal)
    if(found) {
      this.setState({
        message: 'This patient has already been added to the list.',
      })
      window.scrollTo(0, 0)
    } else {
      getPatientGroup.push(
        { pid: this.state.get_patient,
          name: getName,
        }
      )
      this.setState({
        patient_group: getPatientGroup,
        //get_patient: 0,
      })
    }
  }

  removeInputSet1 = (name, id, fields) => {
    var getIndex = fields.findIndex(obj => obj.pid === id)
    //console.log(getIndex)
    fields.splice(getIndex, 1)
    this.setState({ [name]: fields })
  }

  handleSubmit = async (e) => {
    e.preventDefault()
    if(this.state.patient_group.length == 0) {
        this.setState({
          message: 'Please add at least one patient',
        })
        window.scrollTo(0, 0)
    } else {
      axios({
        method: 'post',
        url: connectNode + 'admin/worksheets/edit_assign_by_worksheet',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json;charset=UTF-8'
        },
        data: {
          wid: this.props.match.params.wid,
          uid: this.props.authReducer.uid,
          data: this.state,
        }
      })
      .then((result) => {
        console.log(result['data'])
        if(result['data'] == this.props.match.params.wid) {
          this.setState({
            message: 'Assigned successfully!',
          })
          window.scrollTo(0, 0)
        }
      })
    }
  }

  findLabelByValue = (arr, searchValue) => {
    var label = ''
    var result = arr.find(obj => {
      return obj.value == searchValue
    })
    if(typeof result !== "undefined") {
      label = result.label
    }
    return label
  }

  render() {
    return (
      <div className="admin_log_outcome box_border4">
        <div className="row">
          <div className="small-12 columns headerPage1">
            Worksheet: {this.state.w_name}<br />
            {/* Category: {this.state.category_name} */}
          </div>
        </div>
        <div className="row">
          <div className="small-12 columns ">
            <div className="box_border5">
              <form id="new_self_stigma" onSubmit={this.handleSubmit}>
                <div className="row">
                {(this.state.dataList.length == 0 || this.state.editMode) &&
                <div className="small-12 columns box_inner2 top_space1">
                  { this.state.message !== '' &&
                  <div className="row warning_msg7">
                    <div className="small-12 columns ">
                      <div className="float_left1"><CheckCircleOutlineIcon /></div>
                      <div className="txt_warning_msg1">{ this.state.message }</div>
                    </div>
                  </div>}
                  <div className="row top_space1">
                    <div className="small-12 medium-3 columns bold_txt3">Patients:</div>
                    <div className="small-12 medium-5 columns no_padding_left_float_left">
                    <Select options={this.state.patient_list} placeholder="Type or select..."
                     onChange={this.handleSelectPatient} id="get_patient" />
                    <div className="group_name_list">
                      <ul>
                      {this.state.patient_group.map(each =>
                          <li key={'k'+each.pid}>{each.name}
                          <CancelIcon onClick={ () => this.removeInputSet1('patient_group', each.pid, this.state.patient_group) } /></li>
                      )}</ul>
                    </div>
                    </div>
                    <div className="small-12 medium-1 columns no_padding_left_float_left">
                    <button type="button" className="addInput1" id="patient_name"
                     onClick={() => this.add_patient()} >
                      Add
                    </button>
                    </div>
                  </div>
                </div>}
                </div>

                <div className="row top_space1">
                  <div className="small-12 medium-6 columns">
                    <a onClick={() => this.props.history.goBack()} className="go_back">Go Back</a>
                  </div>
                  <div className="small-12 medium-6columns text_align_right">
                  {(this.state.dataList.length == 0 || this.state.editMode) &&
                    <span>
                    {this.props.authReducer.role <= 3 && this.state.status_submit &&
                    <Button variant="contained" color="primary" disableElevation
                     onClick={this.handleSubmit} type="submit">
                      Submit
                    </Button>}
                    {this.props.authReducer.role <= 3 && !this.state.status_submit &&
                    <Button variant="contained" disabled
                     onClick={this.handleSubmit} type="submit">
                      Submit
                    </Button>}
                    {this.props.authReducer.role == 6 &&
                    <Button variant="contained" disabled
                     onClick={this.handleSubmit} type="submit">
                      Submit
                    </Button>}
                    </span>}
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  //console.log('AddPatient STATE: ', state)
  return state
}

const mapDispatchToProps = (dispatch) => ({
  onLoadPages(response) {
    //console.log('AddPatient mapDispatchToProps')
    dispatch({
      type: 'LOAD_USER_AUTH',
      payload: response,
    })
  },
  onLoadLocation(route, msg) {
    dispatch(loadLocationWithMessage(route, msg))
  },
})

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(AssignWorksheets)
